export const useHandleSuccessfulLogin = () => {
  const resetBannerCookies = () => {
    var allCookies = document.cookie.split(';');
    allCookies.forEach(cookie => {
      let cookieName = cookie.split('=')[0].trim();
      if (cookieName.includes('hide-banner')) {
        Cookies.remove(cookieName);
      }
    })
  }

  const manageCookies = (response) => {
    Cookies.set("is-super-admin", response.is_super_admin, {
      secure: true,
    });
    Cookies.set("admin-role", response.admin_role, { secure: true });
    Cookies.set("user-role", response.admin_role, { secure: true });
    Cookies.set("is-authenticated", "true", { secure: true });
    Cookies.remove("user-type");
    Cookies.remove("leave-plan-id");
    window.localStorage.setItem('company-id', response.default_company_id);
    resetBannerCookies();
  }

  const redirectOnLogin = (response) => {
    let sessionRedirectUrl = sessionStorage.getItem("redirect-url");
    const backendRedirectUrl = response?.redirect_location?.trim();
    const isNotEmployee = ['employee', 'leave_plan_partner'].indexOf(response.admin_role) == -1;
    sessionStorage.removeItem("sso-redirection");
    const tryingToAccessWebApp = sessionRedirectUrl?.includes('webapp');
    if (isNotEmployee && tryingToAccessWebApp) {
      sessionRedirectUrl = null;
      sessionStorage.removeItem("redirect-url");
    }

    let finalRedirectUrl = '/';
    if (backendRedirectUrl) {
      finalRedirectUrl = backendRedirectUrl;
    } else if (sessionRedirectUrl) {
      finalRedirectUrl = sessionRedirectUrl;
      sessionStorage.removeItem("redirect-url");
    }

    window.location = finalRedirectUrl;
    toastr.success("Signed in successfully.");
  }

  return {redirectOnLogin, manageCookies};
};
